window.global = window.global || window;

export {};
